import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Order, ParkingOrder, TransactionVM } from '../../models/orderModel';
import { BookingConfigService } from './booking-config.service';
import { TranslocoService } from '@jsverse/transloco';

@Injectable({
    providedIn: 'root'
})
export class CheckoutServices {

    private hostPath: string;

    constructor(public router: Router, private http: HttpClient, private bookingConfigService: BookingConfigService, private translocoService: TranslocoService
    ) {
        this.hostPath = JSON.parse(this.bookingConfigService.getConfig().IDENTITY);
    }

    public getOrder(orderId: string): Observable<Order> {
        const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/checkout/getorder/${orderId}`;
        return this.http.get<Order>(URL).pipe(
            map(order => {

                return order;
            }),
            catchError(this.handleError)
        );
    }

    public getOrderAdditionalServices(orderId: string): any {
        const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/OrderAdditionalServices/additionalservicesorderid/${orderId}`;
        return this.http.get<any>(URL).pipe(
            map(services => {
                return services;
            }),
            catchError(this.handleError)
        );
    }

    public getOrderShuttles(orderId: string): any {
        const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/OrderShuttle/ordershuttlesorderid/${orderId}`;
        return this.http.get<any>(URL).pipe(
            map(shuttles => {
                return shuttles;
            }),
            catchError(this.handleError)
        );

    }

    public getTransaction(transactionId: string): Observable<Order> {
        const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/checkout/gettransaction/${transactionId}`;
        return this.http.get<Order>(URL).pipe(
            map(transaction => {
                return transaction;
            }),
            catchError(this.handleError)
        );
    }

    public orderParkingsOrder(orderId: string): Observable<ParkingOrder> {
        const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/orderparking/orderparkingsorderid?orderId=${orderId}`;
        return this.http.get<ParkingOrder>(URL).pipe(
            map(parkingOrder => {
                return parkingOrder;
            }),
            catchError(this.handleError)
        );
    }

    public getTransactions(orderId: string): Observable<TransactionVM[]> {
        const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/checkout/transactions/${orderId}`;
        return this.http.get<TransactionVM[]>(URL).pipe(
            map(transactions => {
                return transactions;
            }),
            catchError(this.handleError)
        );
    }

    public downloadReceipt(orderId: string): Observable<Blob> {
        const locale = this.translocoService.getActiveLang() ?? 'sv';
        const url = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/checkout/receipt/${orderId}?locale=${locale}`;
        return this.http.get(url, { responseType: 'blob' }).pipe(
            catchError(this.handleError)
        );
    }

    private handleError(error: Response | any) {
        const errMsg = error.message
            ? error.message
            : error.status
                ? `${error.status} - ${error.statusText}`
                : 'Server error';
        console.error(`checkoutService.handleError ${errMsg}`);
        return throwError(error);
    }
}
